import { render, staticRenderFns } from "./DomicilioEditor.vue?vue&type=template&id=56c0d672"
import script from "./DomicilioEditor.vue?vue&type=script&lang=js"
export * from "./DomicilioEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports